import React from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const SuccessCompleted: React.FC = () => {
    return (
        <div className='content content__success content--created'>
            <div className='content--created--message content__success--message'>
                <CheckBoxIcon />
                <br />
                <span>Task Completed!</span>
            </div>
        </div>
    );
};

export default SuccessCompleted;
